__turbopack_context__.v({
  "articles": "Blog-module-scss-module__rt96rq__articles",
  "categories": "Blog-module-scss-module__rt96rq__categories",
  "subheader": "Blog-module-scss-module__rt96rq__subheader",
});
